
































import Vue from "vue";
import { prop } from "@/fp";

export interface TabItem {
  name: string;
  icon?: string;
  count?: string;
}

export default Vue.extend({
  props: {
    current: {
      type: String,
      default: "",
    },
    tabs: {
      type: Array, // TabItem[]
      default() {
        return [];
      },
    },
  },
  setup(props, { emit }) {
    const onTabClick = (tab: TabItem) => {
      emit("onTab", tab.name);
    };
    return { onTabClick };
  },
});
